import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/revico_logo.png'


const _hoisted_1 = { class: "revico-logo-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  class: "revico-logo",
  href: "https://www.revico.net/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "revico-logo--note" }, "Powered by"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "revico-logo--img",
    src: _imports_0
  })
], -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}